<template lang="pug">
#school-search
    form(onsubmit="return false")
        label(for="school-search-field") Search for school:
        vue-autosuggest(
            ref="schoolSearchField"
            class="autosuggest"
            :suggestions="filteredItems"
            :input-props="{class:'autosuggest__input', onInputChange: updateItems, id: 'school-search-field', 'aria-label': 'Start typing the name of the school and then use the arrow buttons to move through the list of suggested schools.'}"
            :get-suggestion-value="getSuggestionValue"
            @selected="onSelected"
            :sectionConfigs="{ 'default': { limit: 30, } }"
        )
            template(slot-scope="{suggestion}")
              .item(:class="{ active: isActive(suggestion.item.properties) }") {{ suggestion.item.properties.School_Name }}
                .campus-name(v-if="suggestion.item.properties.Campus_Name !== suggestion.item.properties.School_Name") {{ suggestion.item.properties.Campus_Name }}
                .campus-type(v-if="!isActive(suggestion.item.properties)") {{ suggestion.item.properties.School_Type }}
        button.autocomplete-icon.autocomplete-icon-close(
            aria-label="Clear"
            v-if="filteredItems.length"
            @click="clearFilteredItems"
        )

            //- template(slot-scope="{suggestion}")
            //-     span(class="my-suggestion-item") {{suggestion.properties.School_Name}}
        //- Button(@click="clickSearch") Search

</template>

<script>
import { VueAutosuggest } from 'vue-autosuggest';
import { timeout } from 'q';
import { setTimeout } from 'timers';
import { EventBus } from './EventBus';

export default {
    components: {
        VueAutosuggest,
    },
    data: () => ({
        items: [],
        filteredItems: [],
        item: null,
    }),
    computed: {
        activeSchools() {
            return window.app.activeSchools;
        },
        notActiveSchools() {
            return window.app.notActiveSchools;
        },
        activeYearStage() {
            return window.app.BoundarySelector.year_stage;
        },
    },
    created() {
        window.app.SchoolSearch = this;
    },
    methods: {
        isActive(itemProperties) {
            return itemProperties[this.activeYearStage] === 'x';
        },
        updateItems(query) {
            if (!query) {
                this.items = this.activeSchools();
            }
            const q = new RegExp('^' + query, 'i');
            const items = this.activeSchools().filter(s =>
                q.test(s.properties.School_Name)
            );
            items.push(
                ...this.notActiveSchools().filter(s =>
                    q.test(s.properties.School_Name)
                )
            );
            this.items = items;
            this.filteredItems = [
                {
                    data: items,
                },
            ];
        },
        clearFilteredItems() {
            this.$refs.schoolSearchField.searchInput = '';
            setTimeout(() => {
                this.filteredItems = [];
            }, 1);
            setTimeout(() => {
                this.$refs.schoolSearchField.$el.children[0].focus();
            }, 10);
        },
        getSuggestionValue(suggestion) {
            return suggestion.item.properties.School_Name;
        },
        clickHandler(item) {
            // items are selected by default on click, but you can add some more behavior here!
        },
        onSelected(item) {
            this.item = item.item;
            window.track('SchoolSearch', 'onchange');
            this.selectItem(this.item);
        },
        getLabel(school) {
            return school && school.properties.School_Name;
        },
        findSchoolByEntityCode(entityCode) {
            //TODO where does this method really belong
            const school = window.app
                .currentSchools()
                .features.find(
                    s => String(s.properties.Entity_Code) === String(entityCode)
                );
            if (school) {
                EventBus.$emit('school-select', school, false);
            }
        },
        findSchool(schoolname) {
            function getSchool(matchStage) {
                const year_stage = window.app.BoundarySelector.year_stage;
                return window.app
                    .currentSchools()
                    .features.find(
                        s =>
                            s.properties.School_Name.match(
                                new RegExp('^' + schoolname, 'i')
                            ) &&
                            (!matchStage || s.properties[year_stage] === 'x')
                    );
            }
            if (schoolname.length <= 3) {
                return;
            }
            const activeSchool = getSchool(true);
            if (activeSchool) {
                EventBus.$emit('school-select', activeSchool);
                window.track('SchoolSearch', 'findschool', 'active');
                return;
            }
            const inactiveSchool = getSchool(false);
            if (inactiveSchool) {
                EventBus.$emit('school-select', inactiveSchool);
                window.track('SchoolSearch', 'findschool', 'inactive');
            }
            window.track('SchoolSearch', 'findschool', 'none');
        },
        selectItem(item) {
            // console.log('select', item);
            // called when clicking on an item in the dropdown, or pressing enter while navigating the dropdown
            EventBus.$emit('school-select', item, 'school-search');
            window.track('SchoolSearch', 'selectitem');
        },
        clickSearch() {
            // called when clicking the search button, or pressing enter without navigating the dropdown
            if (this.items[0]) {
                this.findSchool(this.items[0].properties.School_Name);
                this.$nextTick(() => {
                    this.items = [];
                    this.$refs.autocomplete.searchText = '';
                });
            }
            window.track('SchoolSearch', 'clicksearch');
            /*
                4 use cases to check:
                    Type query, press enter
                    Type query, click search
                    Type query, press down, press enter
                    Type query, click item in drop down
            */
        },
    },
};
</script>

<style scoped>
#school-search {
    margin-top: 0.5em;
    margin-bottom: 1.5em;
    padding-bottom: 1.5em;
    /* border-top: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6; */
    background: rgba(0, 0, 0, 0.05);
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.05);
}

label {
    padding-top: 1em;
    display: block;
    margin-bottom: 0.5em;
}

.v-autocomplete {
    display: block;
    margin: 0;
}

input {
    margin: 0;
    padding: 10px;
    border-radius: 3px;
    border: 1px solid grey;
    width: 170px;
}

input:focus {
    box-shadow: 0 0 0 2px hsla(0, 0%, 0%, 0.1);
}

button {
    /* height: 35px; */
    margin: 0;
    padding: 10px 5px;
    border-radius: 3px;
    border: 1px solid grey;
}

@media print {
    #school-search {
        display: none !important;
    }
}

#school-search {
    position: relative;
}
</style>
<style>
.autocomplete-icon-close {
    display: inline-block;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    background-repeat: no-repeat;
    background-image: url('../assets/download.svg');
    position: absolute;
    top: 56px;
    right: 22px;
    border: none;
}

.active {
    font-weight: bold;
}

.autosuggest__input {
    outline: none;
    appearance: none;

    color: unset !important;
    border: 1px solid grey;
    border-radius: 3px;
    padding: 10px;
    box-sizing: border-box;

    font-size: 16px;
    width: 100%;
    background-color: white;
    margin: 0;
    color: rgba(0, 0, 0, 0.5);
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.autosuggest__input:focus {
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}

.autosuggest__results {
    margin-top: 1px;
    width: 100%;
    text-align: left;
    border: none;
    border-top: none;
    max-height: 400px;
    overflow-y: auto;
    /* border-bottom: 1px solid grey; */
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
    border-radius: 0 0 3px 3px;
}

.autosuggest__results ul {
    padding: 0;
    margin: 0;
    list-style: none;
}

.autosuggest__results .autosuggest__results_item {
    cursor: pointer;
    background-color: #fff;
    padding: 5px 10px;
    font-size: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.autosuggest__results .autosuggest__results_item:last-child {
    border-bottom: none;
}
.autosuggest__results .autosuggest__results_item:hover,
.autosuggest__results
    .autosuggest__results_item-highlighted.autosuggest__results_item {
    background-color: #eee;
}
.autosuggest__results .autosuggest__results_item abbr {
    opacity: 0.8;
    font-size: 10px;
    display: block;
    font-family: sans-serif;
}

.campus-type {
    color: #555;
    font-size: 10px;
}

.campus-name {
    font-style: italic;
    font-size: 10px;
}

.v-autocomplete .v-autocomplete-input-group {
    border-radius: 3px;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}

.v-autocomplete .v-autocomplete-input-group .v-autocomplete-input {
    outline: none;
    appearance: none;

    width: 100%;
    color: unset !important;
    border: 1px solid grey;
    border-radius: 3px;
    padding: 10px;

    font-size: 16px;
    width: 100%;
    background-color: white;
    height: 40px;
    margin: 0;
    color: rgba(0, 0, 0, 0.5);
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.v-autocomplete .v-autocomplete-list {
    margin-top: 1px;
    width: 100%;
    text-align: left;
    border: none;
    border-top: none;
    max-height: 400px;
    overflow-y: auto;
    /* border-bottom: 1px solid grey; */
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
    border-radius: 0 0 3px 3px;
}
.v-autocomplete .v-autocomplete-list .v-autocomplete-list-item {
    cursor: pointer;
    background-color: #fff;
    padding: 5px 10px;
    font-size: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.v-autocomplete .v-autocomplete-list .v-autocomplete-list-item:last-child {
    border-bottom: none;
}
.v-autocomplete .v-autocomplete-list .v-autocomplete-list-item:hover {
    background-color: #eee;
}
.v-autocomplete .v-autocomplete-list .v-autocomplete-list-item abbr {
    opacity: 0.8;
    font-size: 10px;
    display: block;
    font-family: sans-serif;
}
</style>
